



























































































































































































































import { Component } from "vue-property-decorator";
import feather from "feather-icons";
import UserOnlineComponent from "@/app/components/userOnline/userOnline.component.vue";
import { MANAGE_SPACE_OPTIONS } from "@/resources/constants/sidebarMenu";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import SidebarHelpComponent from "@/app/views/nubii/components/sidebar/components/sidebarHelp.component.vue";
import CollapseButtonComponent from "@/app/views/nubii/components/sidebar/components/collapseButton.component.vue";
import InvitationFormComponent from "@/app/components/manageSpace/components/users/inviteUsers/invitationForm.component.vue";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import Loader from "@/resources/mixins/loader/loader";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import VueTagsInput from "@johmun/vue-tags-input";
@Component({
  name: "user-list-component",
  directives: { ClickOutsideDirective },
  components: {
    InvitationFormComponent,
    CollapseButtonComponent,
    SidebarHelpComponent,
    UserOnlineComponent,
    VueTagsInput,
  },
})
export default class UserListComponent extends mixins(UserValidator, Loader) {
  TYPE_KNOWLEDGE = {
    EXPERIENCE: "EXPERIENCE",
    LEARNIG: "LEARNIG",
    PROJECT_PARTICIPATION: "PROJECT_PARTICIPATION",
  };
  search = "";
  usersSearch = [];
  loading = false;
  searchTimeOut = null;
  MANAGE_SPACE_OPTIONS = MANAGE_SPACE_OPTIONS;
  isOpenFilter = false;
  filterFinder = "";
  knowledge = false;
  projects = false;
  experts = false;
  filterKnowledge = [];
  filterProject = [];
  mounted(): void {
    feather.replace();
    setTimeout(() => {
      this.openChatContainerHeight();
    }, 50);
    window.addEventListener("resize", this.openChatContainerHeight);
  }
  destroyed(): void {
    window.removeEventListener("resize", this.openChatContainerHeight);
  }
  get connectedUsersCounter() {
    return this.$store.getters["SpaceStore/getConnectedUsersCounter"];
  }
  get space(): SpaceInterface {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  get totalUsersInSpace(): number {
    return this.$store.getters["SpaceStore/getTotalUsersInSpace"];
  }
  get user(): SpaceUserInterface {
    feather.replace();
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get usersInSpace() {
    const users =
      this.search === "" && this.filterFinder === ""
        ? this.$store.getters["SpaceStore/getUsersInSpace"]
        : this.usersSearch;
    return users
      .sort((a, b) => (a.connectionStatus === "ONLINE" ? -1 : 1))
      .sort(
        (a, b) =>
          a.user.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase() -
          b.user.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
      )
      .sort((a, b) =>
        a.connectionStatus === "ONLINE"
          ? a.user.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase() >
            b.user.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
            ? 1
            : -1
          : 0
      );
  }
  get onBoarding(): void {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  getMoreUsers(): void {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space)
      this.$store.dispatch("SpaceStore/getSpaceUsersAction", {
        superSpaceId: space.superSpace.id,
        callback: () => {
          document.getElementById("user-list").scrollTop =
            document.getElementById("user-list").scrollHeight - 800;
        },
      });
  }
  get disabledLoader(): boolean {
    const lastPage = this.$store.getters["SpaceStore/getLastPage"];
    const page = this.$store.getters["SpaceStore/getUsersInSpacePage"];
    return page > lastPage;
  }
  onFilterFinder(): void {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.$store.dispatch("SpaceStore/searchUserTagAction", {
        superSpaceId: space.superSpace.id,
        type: this.knowledge ? "knowledge" : "project",
        search: this.filterFinder.trim(),
        callback: (response) => {
          this.usersSearch = response;
          this.loading = false;
        },
      });
    }, 1000);
  }
  onSearch(): void {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.$store.dispatch("SpaceStore/searchSpaceUserAction", {
        superSpaceId: space.superSpace.id,
        name: this.search,
        callback: (response) => {
          this.usersSearch = response;
          this.loading = false;
        },
      });
    }, 1000);
  }
  onSearchExperts(): void {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.$store.dispatch("SpaceStore/searchUserTagAction", {
        superSpaceId: space.superSpace.id,
        type: "expertise",
        search: this.search,
        callback: (response) => {
          this.usersSearch = response;
          this.loading = false;
        },
      });
    }, 1000);
  }
  openChatContainerHeight(): void {
    const userListContainer = document.getElementById("user-list-container");
    const usersContainer = document.getElementById("user-list");
    usersContainer.style.height = userListContainer.clientHeight - 300 + "px";
  }
  addFavourite(isFavourite: boolean) {
    this.startLoader(this.$store);
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    this.$store.dispatch("SpaceStore/addToFavouriteAction", {
      spaceId: this.space.id,
      data: { isFavourite: !isFavourite },
      callback: (response) => {
        this.space.isFavourite = response.isFavourite;
        this.stopLoader(this.$store);
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
      },
    });
  }
  checkGetUser() {
    this.search = "";
    if (!this.knowledge && !this.projects && !this.experts) {
      this.filterFinder = "";
      this.onSearch();
    }
  }
  getFilterTags() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (!space) return;
    this.search = "";
    this.experts = false;
    this.knowledge = false;
    this.projects = false;
    this.$store.dispatch("SuperSpaceStore/getSuperSpaceTagAction", {
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        this.filterKnowledge = this.createJsonTag(
          response.EXPERIENCE.concat(response.LEARNIG)
        );
        this.filterProject = this.createJsonTag(response.PROJECTS);
      },
      callbackError: (error) => {},
    });
  }
  createJsonTag(array: any[]): string[] {
    let newArray = [];
    array.forEach((tag) => {
      newArray.push(tag);
    });
    return newArray.length == 0 ? ["No tag"] : newArray;
  }
}
